// Modul zajistí přidání doporučených článků do galerie na mobilních zařízeních
/*
    Testování na devu:
    1) zakomentovat podmínku pro lokální prostředí (viz. řádek 20-22)
    2) do konstanty 'canonicalUrl' vložit PRODUKČNÍ URL článku !!! (viz. řádek 16)
*/

const removeOldRecommendedArticles = () => {
    const oldInsertions = document.querySelectorAll('.recommended-articles');
    oldInsertions.forEach((div) => div.remove());
};

export const AddGalleryLayerRecommendedArticles = (trigger) => {
    const { galleryLayerRecommendedArticlesCanonicalUrl } = trigger.dataset;
    const canonicalUrl = galleryLayerRecommendedArticlesCanonicalUrl || null;
    // const canonicalUrl = 'https://www.blesk.cz/clanek/celebrity-ceske-celebrity/825070/baba-z-ledu-kronerova-rusi-predstaveni-ceka-ji-operace.html'; // Testovací URL

    const feedId = 'AP_aDVAFKCYRG6YyRT4phKQTg';

    // Vypnout pro lokální prostředí, ať se zbytečně neposílají requesty
    if (window.location.href.indexOf('local.cnci.cz') !== -1) {
        return;
    }

    let articlesQueue = [];
    let articlesLoaded = false;
    let fetchStarted = false;

    const insertRecommendedArticles = () => {
        const imgWraps = document.querySelectorAll('.cnc-gallery-slider__img-wrap');

        // Odstranit staré divy
        removeOldRecommendedArticles();

        // Vložit jen pokud je viewport menší než 500px
        if (window.innerWidth < 500 && articlesLoaded && articlesQueue.length > 0) {
            let articleIndex = 0;

            // Projít všechny obrázky v galerii
            imgWraps.forEach((imgWrap, index) => {
                if ((index + 1) % 5 === 0) {
                    let articlesHtml = '';

                    // Přidat články do HTML
                    for (let i = 0; i < 3; i++) {
                        const article = articlesQueue[articleIndex++];
                        if (!article) break;

                        // Přidání GTM události
                        const gtmEvent = {
                            event: 'list_itemClick',
                            _clear: true,
                            item: {
                                elementId: article.elementId || '',
                                type: 'article',
                                list: article.list || '',
                                position: articleIndex,
                                systemId: article.systemId || 'blesk',
                                id: article.id || '',
                                versionId: article.updateTime || '',
                                title: article.title || '',
                                url: article.url || '',
                                colset: article.colset || '',
                                category: article.sections || [],
                                source: article.source || 'Marfel',
                                listLayout: article.listLayout || 'galleryRecommenderMarfeel',
                            },
                        };

                        // Vytvoření onclick atributu s GTM událostí
                        const onClick = `window.dataLayer = window.dataLayer || []; window.dataLayer.push(${JSON.stringify(gtmEvent)});`;

                        // Hydratace
                        articlesHtml += `
                            <a href="${article.url}"
                               class="recommended-articles__item"
                               title="${article.title}"
                               aria-label="Odkaz na článek: ${article.title}"
                               onclick="${onClick}">
                                <img src="${article.img}" alt="${article.title}" class="recommended-articles__image" />
                                <div class="recommended-articles__item-title">${article.title}</div>
                            </a>
                        `;
                    }

                    // Pokud se hydratovaly články
                    if (articlesHtml.trim() !== '') {
                        const newDiv = `
                            <div class="recommended-articles">
                                <h3 class="recommended-articles__title" aria-label="Nadpis: Doporučujeme" title="DOPORUČUJEME">DOPORUČUJEME</h3>
                                <div class="recommended-articles__list">
                                    ${articlesHtml}
                                </div>
                            </div>
                        `;
                        // Vložit za každý pátý obrázek v galerii
                        imgWrap.insertAdjacentHTML('afterend', newDiv);
                    }
                }
            });
        }
    };

    // Funkce pro fetch dat a jejich vložení podle velikosti viewportu
    const fetchAndInsertIfNeeded = () => {
        if (window.innerWidth < 500 && !fetchStarted) {
            fetchStarted = true;

            // Najít URL pro článek, ke kterému se má doporučovat
            if (canonicalUrl)
                fetch(
                    `https://experiences.mrf.io/recommenderexperience/render.json?id=${feedId}${canonicalUrl ? `&canonical_url=${canonicalUrl}` : ''}`,
                )
                    .then((response) => response.json())
                    .then((data) => {
                        articlesQueue = data.recommendation || data.items || data || [];
                        articlesLoaded = true;
                        insertRecommendedArticles();
                    });
        } else if (window.innerWidth >= 500) {
            // Pokud se zvětší viewport, smaž doporučené články
            const oldInsertions = document.querySelectorAll('.recommended-articles');
            oldInsertions.forEach((div) => div.remove());
        } else if (window.innerWidth < 500 && articlesLoaded) {
            // Pokud už jsou data načtena a někdo zmenší/zvětší viewport
            insertRecommendedArticles();
        }
    };

    // Prvotní kontrola
    fetchAndInsertIfNeeded();
    // Sleduj změnu velikosti okna
    window.addEventListener('resize', fetchAndInsertIfNeeded);
};
